import Icon, {icons} from './icon'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import times from 'lodash/times'

import {colors} from '../styles'
import {css} from 'glamor'

const MAX_HALF_STARS = 10

const style = {
  activeStar: css({
    color: colors.actionOrange
  }),
  container: css({
    display: 'inline-flex',
    '& .fa': {
      '&:nth-child(2n+1)': {
        marginRight: '-1em'
      }
    }
  }),
  inactiveStar: css({
    color: colors.grayLighter
  })
}

export default class Stars extends PureComponent {
  render() {
    const {rating, style: customStyle} = this.props
    const activeStars = Math.round(rating * 2)

    return (
      <span {...css(style.container, customStyle)}>
        {times(MAX_HALF_STARS, (index) => (
          <Icon
            key={index}
            className={index % 2 ? 'fa-flip-horizontal' : null}
            icon={icons.starHalf}
            {...(index < activeStars ? style.activeStar : style.inactiveStar)}
          />
        ))}
      </span>
    )
  }
}

Stars.propTypes = {
  rating: PropTypes.number,
  style: PropTypes.object
}
